import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingArgument } from './components/ClosingArgument';
import { EverythingIncluded } from './components/EverythingIncluded';
import { VisualSection } from './components/VisualSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { ProductGallery } from './components/ProductGallery';
import { SolutionReveal } from './components/SolutionReveal';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { VolumesSection } from './components/VolumesSection';
import { META_PIXEL_ID } from './utils/tracking';
const SITE_TITLE = 'Welding Instructor Atlas | 6-in-1 Visual Welding Technology & Technical Training System';
const SITE_DESCRIPTION = 'The complete 6-in-1 visual welding technology and technical training system for welding instructors, technical schools and training workshops: 6 volumes, 300 visual training pages and 5 bonuses. Instant access.';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
interface AppProps {
  showTestimonials?: boolean;
}
export function App({
  showTestimonials = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    document.title = SITE_TITLE;
    try {
      const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
        let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
        if (!tag) {
          tag = document.createElement('meta');
          tag.setAttribute(attr, key);
          document.head.appendChild(tag);
        }
        tag.setAttribute('content', content);
      };
      setMeta('name', 'description', SITE_DESCRIPTION);
      setMeta('property', 'og:title', SITE_TITLE);
      setMeta('property', 'og:description', SITE_DESCRIPTION);
      setMeta('property', 'og:type', 'website');
      setMeta('name', 'twitter:card', 'summary_large_image');
      setMeta('name', 'theme-color', '#16191E');
    } catch (error) {
      console.warn('Meta tags update failed:', error);
    }
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-white text-slate-700 antialiased" data-id="element-0" data-mp="1r5kb7n0wuujy">
      <main data-id="element-1" data-mp="1w3lvucdzj1xj">
        <Hero data-id="element-2" data-mp="1w210ikjujeym" />
        {showTestimonials && <TestimonialsStrip data-id="element-3" data-mp="1w0znwbn6mkes" />}
        <ProductGallery data-id="element-4" data-mp="1i4417ge0cug9" />
        <PainPoints data-id="element-5" data-mp="1i2j8zxf61nlk" />
        <SolutionReveal data-id="element-6" data-mp="1i3b291laj98o" />
        <VisualSection data-id="element-7" data-mp="1i5xcj8zkg2ul" />
        <VolumesSection data-id="element-8" data-mp="1m4mu7drn06k1" />
        <BonusSection data-id="element-9" data-mp="1m3uze55v6cut" />
        <PricingSection data-id="element-10" data-mp="1m3cw4oksayde" />
        <ClosingArgument data-id="element-11" data-mp="6ofd2lp0ppdv" />
        <Guarantee data-id="element-12" data-mp="6o5xzt5ih2my" />
        <FAQ data-id="element-13" data-mp="6nmfobby8c8e" />
        <FinalCTA data-id="element-14" data-mp="6mum161wwokr" />
        <EverythingIncluded data-id="element-15" data-mp="6qs55rohpg4n" />
      </main>
      <Footer data-id="element-16" data-mp="aq9benbqqhav" />
      <noscript data-id="element-17" data-mp="aqsif8zurla4">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-18" data-mp="arkbod5z96x8" />
      </noscript>
    </div>;
}